import { useTranslation } from 'react-i18next';

import { Map, Plus } from 'lucide-react';

import { greyP5 } from '../../theme.ts';
import { EXAMPLES_URL, useDrawingExamples } from './drawingExamples';

/** The Drawings tab's left column, laid out like the Projects sidebar (hidden on phones). */
export function DrawingsSidebar({ onCreate, onOpenExamples }: { onCreate: () => void; onOpenExamples: () => void }) {
  const { t } = useTranslation();
  const examples = useDrawingExamples();
  return (
    <nav
      className="flex-shrink-0 hidden md:inline-flex flex-col border-r"
      style={{ width: '240px', height: 'calc(100vh - 224px)', borderColor: greyP5 }}
    >
      <div className="bg-black overflow-y-auto h-full">
        <div className="flex flex-row items-center w-full h-[44px] px-8 text-white font-medium border-b border-greyP5 text-xs bg-greyP5">
          {t('drawings.yourDrawings')}
        </div>
        <div className="flex flex-col p-4 space-y-3">
          <button
            onClick={onCreate}
            className="flex items-center rounded-full font-medium transition-colors duration-200 text-xs bg-white text-black hover:bg-gray-100 disabled:opacity-50"
            style={{ height: '36px', paddingLeft: '18px', paddingRight: '18px', gap: '8px' }}
          >
            <Plus className="w-5 h-5" />
            {t('drawings.newDrawing')}
          </button>
          <button
            onClick={onOpenExamples}
            className="w-full rounded-xl border border-lime-400/40 bg-lime-400/[0.06] p-3 text-left transition-colors hover:border-lime-400/80 hover:bg-lime-400/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-lime-400"
          >
            <span className="flex items-center gap-2 text-xs font-medium text-lime-400">
              <Map className="w-4 h-4" />
              {t('drawings.empty.exampleTitle')}
            </span>
            <span className="mt-1 block text-[11px] leading-snug text-gray-400">
              {t('drawings.examples.sidebarHint')}
            </span>
            {Array.isArray(examples) && examples.length > 0 && (
              <span className="mt-2.5 flex gap-1.5">
                {examples.slice(0, 3).map((example) => (
                  <img
                    key={example.id}
                    src={EXAMPLES_URL + example.preview}
                    alt=""
                    className="h-12 w-12 rounded-md border border-white/10 object-cover"
                  />
                ))}
              </span>
            )}
          </button>
          <p className="px-2 text-[11px] leading-relaxed text-gray-500">{t('drawings.subtitle')}</p>
        </div>
      </div>
    </nav>
  );
}
